module.exports = __webpack_public_path__ + "img/3.93363831.png";